import type { QueuedStreamCommand } from '../../types/StreamCommandQueue';

/**
 * Merges consecutive 'streamCommand' type commands in the provided array by concatenating their chunks.
 * Other command types are preserved as is.
 *
 * @param commandsToProcess - An array of QueuedStreamCommand objects to be processed.
 * @returns A new array of QueuedStreamCommand objects with merged 'streamCommand' types.
 */
export function mergeStreamCommands(
	commandsToProcess: QueuedStreamCommand[],
): QueuedStreamCommand[] {
	const mergedCommands: QueuedStreamCommand[] = [];

	for (const command of commandsToProcess) {
		const lastCommand = mergedCommands[mergedCommands.length - 1];
		// Check if we can merge the current command with the last one
		if (
			command.type === 'streamCommand' &&
			lastCommand &&
			lastCommand.type === 'streamCommand' &&
			command.actionId === lastCommand.actionId
		) {
			lastCommand.chunk = command.chunk;
		} else {
			// Otherwise, just push the command to mergedCommands
			mergedCommands.push(command);
		}
	}

	return mergedCommands;
}
